import React from "react";

const Unique = () => {
  return (
    <div className="flex flex-wrap space-y-4 mt-8 md:space-y-0 md:flex-nowrap items-center  px-8 xl:px-40">
      <h3 className="font-poppins text-[2.5rem] leading-[2.75rem] font-medium xl:text-7xl xl:leading-[4.75rem]">
        Simply Unique<span className="text-gray-500">/</span> Simply Better
        <span className="text-gray-500">.</span>
      </h3>

      <p className="font-inter text-sm font-normal text-gray-500 xl:text-base">
        <span className="font-inter text-sm font-semibold text-gray-900 xl:text-base xl:font-semibold">
          3legant
        </span>{" "}
        is a gift & decorations store based in HCMC, Vietnam. Est since 2019.
      </p>
    </div>
  );
};

export default Unique;
